import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class ChocolateBox extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene) {
    super(scene);

    this.box = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._candy_box, this);
  }
}